import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environments';
import { ITransaction, TransactionType } from '../../../../../../shared/schemas/synagogueSchema';
import { httpOptions } from '../../../services/login.service';



@Injectable({
  providedIn: 'root'
})
export class SynagogueService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) { }

  async getTransactions(): Promise<TransactionType[]> {
    return lastValueFrom(this.http.get<TransactionType[]>(`${this.API_URL}/synagogue/transactions`))
  }
  async getTransactionById(id: string): Promise<TransactionType> {
    return lastValueFrom(this.http.get<TransactionType>(`${this.API_URL}/synagogue/transactions/${id}`))
  }
  /** Server replies with the new synagogue balance after this transaction. */
  async addTransaction(transaction: ITransaction): Promise<{ success: boolean; transactionId: string; balance: number }> {
    return lastValueFrom(this.http.post<{ success: boolean; transactionId: string; balance: number }>(`${this.API_URL}/synagogue/transactions`, transaction, httpOptions))
  }
  /** Server replies with the rebuilt synagogue balance after the delete. */
  async delTransaction(id: string): Promise<{ success: boolean; balance: number }> {
    return lastValueFrom(this.http.delete<{ success: boolean; balance: number }>(`${this.API_URL}/synagogue/transactions/${id}`))
  }
}
